
    <span class="spin-circle"></span>
    <span class="message" *ngIf="message">{{ message }}</span>
  